const APP_BASE_API_URL='https://apidev.bitz.me/redpay-api/v2/'

const APP_CLIENT_ID='1ad9f538-efc4-3ce0-acb5-f749b0924fe5'

export default { APP_BASE_API_URL, APP_CLIENT_ID };